module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4djVf"))).then(() => module.bundle.root('dJXJK'));